import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addLogToReport } from '@americanexpress/one-app/ducks';
import { getVaultConfig } from '../../redux/selectors';
import { useOCC } from '../../components/OCCFlow/context/occContext';
import { decrypt3DES } from '../occDecrypt';
const useOccEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const encryptionKeys = useSelector(getVaultConfig);
  const {
    params,
    emailObj,
    setEmailObj
  } = useOCC();
  //   console.log('Params:', params);
  const add = params === null || params === void 0 ? void 0 : params.add;
  useEffect(() => {
    //  const encryptedEmail = encryptAES('a@a1.com');

    //  console.log('encryptedEmail', encryptedEmail);

    //  const dec = decryptAES(encryptedEmail);

    //  console.log('decryptedEmail', dec);

    if (!add || emailObj || !encryptionKeys.encryptionKey || !encryptionKeys.desIv) return;
    try {
      const decryptedEmail = decrypt3DES(add, encryptionKeys);
      if (!decryptedEmail) {
        navigate('/occ/optouterror');
        return;
      }
      const maskEmail = email => {
        const [name, domain] = email.split('@');
        if (!name || !domain) return email;
        const masked = name.length > 2 ? `${name[0]}*****${name[name.length - 1]}` : `${name[0]}***`;
        return `${masked}@${domain}`;
      };
      dispatch(addLogToReport('info', `Decrypted email: ${decryptedEmail}`));
      setEmailObj({
        maskedEmail: maskEmail(decryptedEmail),
        emailAddress: decryptedEmail,
        encryptedEmail: add
      });
    } catch (err) {
      console.error('Decrypt Error:', err);
      navigate('/occ/optouterror');
    }
  }, [add, emailObj, setEmailObj, navigate, encryptionKeys.encryptionKey, encryptionKeys.desIv]);
  return emailObj;
};
export default useOccEmail;